import { Box, MenuItem, MenuList } from '@ff-it/ui';
import { Breadcrumb, IndexContainer } from 'components';
import { FeaturedIcon } from 'components/Icon';
import { UserAvatar } from 'components/UserAvatar';
import { useTimeAgo } from 'hooks/useTimeAgo';
import { Notification } from 'modules/notifications/types';
import { ReactElement } from 'react';
import { Outlet, RouteObject } from 'react-router';
import { NavLink } from 'react-router-dom';
import { MarkAllSeen, NotificationSeenToggle } from './SeenToggle';
import { seenRow } from './styles.css';
import { Header } from 'components/Header';
import { NotificationClickHandler } from './NotificationClickHandler';
import { ContentObjectWidget } from 'components/widgets/ContentObjectWidget';
import { ControlledTableColumns } from 'components/ControlledTable';

function Created({ created_at }: { created_at: string }): ReactElement {
  const timeAgo = useTimeAgo(created_at);
  return <Box title={created_at}>{timeAgo}</Box>;
}

const columns: ControlledTableColumns<Notification> = [
  {
    key: 'actor',
    content: 'Actor',
    width: '60px',
    render: ({ actor }) => (actor ? <UserAvatar user={actor} size="xs" /> : null),
  },
  {
    width: '50px',
    key: 'fields.icon',
    cellProps: {
      flush: true,
      textAlign: 'center',
    },
    render: ({ fields: { icon } }) => {
      return icon ? <FeaturedIcon icon={icon} /> : null;
    },
    configLabel: 'Icon',
  },
  {
    key: 'fields.title',
    content: 'Event',
    required: true,
    render: (notification) => <NotificationClickHandler notification={notification} />,
  },
  {
    key: 'fields.object',
    content: 'Context',
    render: ({ fields: { object } }) => <ContentObjectWidget content_object={object} />,
  },
  {
    key: 'fields.description',
    content: 'Description',
    render: ({ fields: { description } }) => description,
  },
  {
    key: 'created_at',
    content: 'Created',
    render: ({ created_at }) => <Created created_at={created_at} />,
  },
  {
    key: 'last_seen_at',
    content: 'Seen',
    cellProps: {
      textAlign: 'right',
    },
    render: (notification) => <NotificationSeenToggle notification={notification} />,
  },
];

const tableProps = {
  getRowClassName: ({ last_seen_at }: Notification) => (last_seen_at ? seenRow : undefined),
};
export const route: RouteObject = {
  path: 'notifications',
  element: (
    <>
      <Breadcrumb>Notifications</Breadcrumb>
      <Header
        // heading="Notifications"
        menu={
          <MenuList variant="pills" direction="horizontal">
            <MenuItem label="All" component={NavLink} to="" end />
            <MenuItem label="Unseen" component={NavLink} to="unseen" />
          </MenuList>
        }
      />
      <Outlet />
    </>
  ),
  children: [
    {
      index: true,
      element: (
        <IndexContainer
          title="All"
          filterFields={null}
          breadCrumb="All"
          url="notifications/notifications/"
          columns={columns}
          tableProps={tableProps}
          toolbar={<MarkAllSeen />}
        />
      ),
    },
    {
      path: 'unseen',
      element: (
        <IndexContainer
          filterFields={null}
          title="Unseen"
          breadCrumb="Unseen"
          url="notifications/notifications/unseen/"
          columns={columns}
          tableProps={tableProps}
          toolbar={<MarkAllSeen />}
        />
      ),
    },
  ],
};
